import { render, staticRenderFns } from "./Withdrawals.vue?vue&type=template&id=b5730ebc"
import script from "./Withdrawals.vue?vue&type=script&lang=js"
export * from "./Withdrawals.vue?vue&type=script&lang=js"
import style0 from "./Withdrawals.vue?vue&type=style&index=0&id=b5730ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports